/* WebComponentStoreLocator template */
import { Host, h } from '@stencil/core'; // eslint-disable-line @typescript-eslint/no-unused-vars

const WebComponentStoreLocatorTsx = () => (
  <Host>
    <cwc-map-headline></cwc-map-headline>
    <cwc-map-content>
      <cwc-map></cwc-map>
      <cwc-map-sidebar></cwc-map-sidebar>
      <cwc-map-location></cwc-map-location>
      <cwc-map-notice></cwc-map-notice>
    </cwc-map-content>
  </Host>
);

export default WebComponentStoreLocatorTsx;
